import { render, staticRenderFns } from "./EmptyChatInvite.vue?vue&type=template&id=20356532&scoped=true&"
import script from "./EmptyChatInvite.vue?vue&type=script&lang=js&"
export * from "./EmptyChatInvite.vue?vue&type=script&lang=js&"
import style0 from "./EmptyChatInvite.vue?vue&type=style&index=0&id=20356532&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20356532",
  null
  
)

export default component.exports